import IdealStudio from "../../../core/editor/main";
import { addBox, configScore, updatePluginToolbar } from "../../../common/actions";

/**
 * Üretilen interaktif öğeyi sahneye koyar.
 *
 * ──────────────────────────────────────────────────────────────────────────
 * NEDEN ORTAK BİR DOSYA
 * ──────────────────────────────────────────────────────────────────────────
 * Aynı sonucu sahneye koyan İKİ yol var:
 *   • İnteraktif panelindeki onay kartı ("Sahneye ekle"),
 *   • iş tepsisindeki (JobWidgetHost) onay — pencere kapatılmışsa tek yol bu.
 *
 * Bu mantık bir süre yalnızca panelde durdu ve tepsiden eklemek hiçbir şey
 * yapmıyordu: iş onaylanıyor, kart kapanıyor, sahneye kutu girmiyordu.
 * Scene-visual'da da aynısı yaşanmış ve o dalın yorumunda yazıyor. İki
 * çağıranın aynı işi iki ayrı yerde yapması, birinin sessizce geride kalma
 * biçimi — o yüzden tek yerde.
 */

/**
 * @returns {{ ok: boolean, reason?: string, boxId?: string }}
 */
export function applyInteractiveResult(dispatch, result, navId) {
  const r = result && typeof result === "object" ? result : null;
  if (!r) {
    return { ok: false, reason: "no-result" };
  }

  // DÜZENLEME sonucu sahneye YENİ kutu koymaz: var olan kutunun state'ini
  // değiştirir ve bunu zaten AI düzenleme ekranı yapar (kutunun kimliğini
  // yalnızca o bilir — düzenleme isteği boxId taşımıyor). Tepsiden onaylanan
  // bir düzenleme işi için yapılacak doğru şey hiçbir şey yapmamak; yeni bir
  // kutu eklemek aynı aktiviteyi sahnede ikizlerdi.
  if (r.mode === "edit") {
    return { ok: true, reason: "edit-applied-in-place" };
  }

  if (!r.box || !r.toolbar) {
    return { ok: false, reason: "no-box" };
  }

  const { box, toolbar, exercise } = r;
  const boxId = r.boxId || box.id;
  const structure = toolbar.structure || {};
  const plugin = IdealStudio.Plugins.get("InteractiveItem");
  const parent = navId || box.parent;
  if (!parent) {
    return { ok: false, reason: "no-scene" };
  }

  dispatch(
    addBox(
      {
        id: boxId,
        parent,
        container: 0,
        // `config` SADECE puanlı tipte geçilir. `exercises{}` kaydını ADD_BOX
        // reducer'ı açıyor ve açma koşulu config'teki kategorinin
        // "evaluation" olması. Puansız bir öğe (çevrilen kartlar, zaman
        // çizelgesi) için kayıt açılsaydı, ağırlığı sıfır olsa bile eğitimin
        // "kaç soru doğru" paydasında görünür ve öğrenci hiç cevaplamadığı
        // bir şeyden eksik alırdı.
        ...(exercise && plugin ? { config: plugin.getConfig() } : {}),
      },
      true,
      true,
      "",
      toolbar.style || {},
      toolbar.state || {},
      toolbar.structure,
      {
        name: toolbar.pluginId,
        position: box.position || { x: "0%", y: "0%", type: "absolute" },
        width: structure.width ?? 88,
        height: structure.height ?? 80,
        widthUnit: "%",
        heightUnit: "%",
      }
    )
  );

  // Reducer yeni egzersizi ağırlık 0 ile açar — yani "puanlı" dediğimiz bir
  // aktivite eğitimin toplamına sıfır katkıyla girer. Backend'in verdiği
  // ağırlık hemen ardından yazılır; yazar puan panelinden değiştirebilir.
  if (exercise?.weight) {
    dispatch(configScore(boxId, "weight", exercise.weight, parent));
  }

  // ADD_BOX kutuyu `toolbar.state` ile kuruyor; yine de üç alanı açıkça
  // yazıyoruz çünkü okunan kopya `pluginToolbarsById` ve bu üçü olmadan kutu
  // çalışmaz: doküman (htmlUrl), veri (item) ve AI düzenlemenin geri okuduğu
  // kaynak adı (sourceBlobName).
  const state = toolbar.state || {};
  ["htmlUrl", "item", "sourceBlobName"].forEach((key) => {
    if (state[key] !== undefined) {
      dispatch(updatePluginToolbar(boxId, "main", "state", key, state[key], [], null));
    }
  });

  return { ok: true, boxId };
}
